import type { Vehicle } from "@models/repairInformation";

/** Stable id of a vehicle scope: `type:body:country`. */
export function vehicleId(vehicle: Pick<Vehicle, "typeId" | "bodyId" | "countryCode">): string {
  return `${vehicle.typeId}:${vehicle.bodyId}:${vehicle.countryCode}`;
}

export function vehicleLabel(vehicle: Vehicle): string {
  const name = [vehicle.make, vehicle.model, vehicle.typeName].filter(Boolean).join(" ");
  return `${name || "Vehicle"} · ${vehicle.typeId}/${vehicle.bodyId}`;
}
